<button
  class="search-subscription-button"
  cdkOverlayOrigin
  #trigger="cdkOverlayOrigin"
  (click)="open()"
>
  <i
    class="search-subscription-button__icon material-icon material-icon--orange material-icon--outlined"
  >
    notifications
  </i>
  <span class="search-subscription-button__text">
    {{ 'searchSubscription.save' | i18n }}
  </span>
</button>
